angular
    .module('app.controllers')
    .controller(
        'EditAreaCtrl',
        function (
            $rootScope,
            $state,
            $translate,
            notify,
            formValidator,
            areasService,
            area,
            allUserOptions,
            allGroupsOptions,
            installationOptions,
            woodworkOptions,
            currencyOptions,
            countryOptions,
            unitOptions,
            interestStatusOptions,
            taskStatusOptions,
            categoryOptions,
            projectStatusOptions,
            phaseStatusOptions
        ) {
            const vm = this;

            vm.area = area;
            vm.unitOptions = unitOptions;
            vm.woodworkOptions = woodworkOptions;
            vm.installationOptions = installationOptions;

            // tylko użytkownicy przypisani do danego obszaru
            vm.userOptions = _.filter(allUserOptions, (user) => user.areas_id.includes(vm.area.id));

            // tylko grupy przypisane do danego obszaru
            const groupOptions = _.filter(allGroupsOptions, (group) => $rootScope.$session.area.id === parseInt(group.area_id));

            vm.managerKeys = ['projects.measurement', 'projects.installation', 'projects.service', 'projects.transport', 'tasks', 'interests'];
            vm.defaultsKeys = {
                currency_id: currencyOptions,
                country_id: countryOptions,
                unit_piece_id: unitOptions,
                interest_status_id: interestStatusOptions,
                interest_win_id: interestStatusOptions,
                interest_loss_id: interestStatusOptions,
                task_status_id: taskStatusOptions,
                task_unfinished_id: taskStatusOptions,
                task_category_id: categoryOptions,
                project_status_started: projectStatusOptions,
                project_status_closed: projectStatusOptions,
                phase_status_started: phaseStatusOptions,
                phase_status_closed: phaseStatusOptions,
                crew_id_measurement: groupOptions,
                crew_id_installation: groupOptions,
                crew_id_service: groupOptions,
                crew_id_transport: groupOptions,
                phase_daily_limit_transport: 'number',
                phase_daily_limit_transport_message: 'text',
                phase_daily_limit_installation: 'number',
                phase_minimum_days_buffer_installation: 'number',
                notify_about_complaint: 'number',
            };

            // form validation
            const fv1 = formValidator('#AreaBaseForm', vm);

            const fv2 = formValidator('#AreaSettingsForm', vm);
            const fv3 = formValidator('#AreaCalculationsForm', vm);

            vm.saveArea = () => {
                // wymuszamy obliczenie dla wszystkich formularzy
                let errors;
                if (vm.area.id) {
                    errors = _.sum([fv1.isValid(false) ? 0 : 1, fv2.isValid(true) ? 0 : 1, fv3.isValid(true) ? 0 : 1]);
                } else {
                    errors = fv1.isValid(false) ? 0 : 1;
                }
                if (errors) {
                    return;
                }
                // @todo: po aktualizacji obszarów powinny się odświeżyć dane użytkownika

                const redirectAfterSave = 0 == vm.area.id;
                const info = notify.info($translate.instant('saving'));
                notify.global(1);

                areasService.save(vm.area).then((response) => {
                    vm.area = response;

                    info.close();
                    notify.success($translate.instant('saved'));
                    notify.global(0);
                    $rootScope.$broadcast('edit-panel-ready');

                    if (redirectAfterSave) {
                        $state.go('restricted.areas_edit', { id: vm.area.id });
                    }
                });
            };
        }
    );
